import React from 'react'
import {Link} from 'react-router-dom'

import prdimg1 from '../../images/icon/document.svg'
import prdimg2 from '../../images/icon/bar-graph.svg'
import prdimg3 from '../../images/icon/clipboard.svg'


const Features = (props) => {
    const ClickHandler = () =>{
        window.scrollTo(10, 0);
     }


     const featres = [
    {
        fIcon: prdimg1,
        title: 'Custom-Built Software',
        des: 'We create fully customized websites and apps that align perfectly with your business goals and customer expectations.',
        link: '/service-single/full-stack-solutions',
    },
    {
        fIcon: prdimg2,
        title: 'Scalable & Future-Ready',
        des: 'Our solutions are built to scale smoothly as your business grows, with clean code and modern technologies.',
        link: '/service-single/web-development',
    },
    {
        fIcon: prdimg3,
        title: 'From Idea to Launch',
        des: 'We work closely with you from the first discussion to the final delivery, making sure everything runs smoothly.',
        link: '/service-single/it-consulting',
    },
];



    return(
        <section className={`wpo-features-section section-padding  ${props.featuresClass}`}>
            <div className="container">
                <div className="row">
                    {featres.map((featres, fitem) => (
                        <div className="col-lg-4 col-md-6 col-12" key={fitem}>
                            <div className="wpo-features-item">
                                <div className="wpo-features-icon">
                                    <div className="icon">
                                        <img src={featres.fIcon} alt=""/>
                                    </div>
                                </div>
                                <div className="wpo-features-text">
                                    <h2><Link onClick={ClickHandler} to={featres.link}>{featres.title}</Link></h2>
                                    <p>{featres.des}</p>
                                </div>
                            </div>
                        </div>
                    ))}
                </div>
            </div>
        </section>
    )
}

export default Features;